import { InputTextProps } from "@bluframe/blublocks"

import EditableField from "./EditableField"

export interface Props {
  error?: InputTextProps["error"]
  errorText?: InputTextProps["errorText"]
  fieldRef: React.Ref<HTMLInputElement>
  id: string
  infoText?: InputTextProps["infoText"]
  isEditMode: boolean
  label: string
  onChange?: InputTextProps["onChange"]
  name: string
  value: string
}

export interface ComponentProps extends Props {}

export default EditableField
